import { selectedPartnerProductOrderCartItemsState } from "@/atoms/item/selected-partner-product-order-cart-items-state";
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { PartnerCompleteOrderPanel } from "@/components/panel/PartnerCompleteOrderPanel";
import { PartnerCompleteOrderPaymentTable } from "@/components/table/partner-complete-order-payment-table/PartnerCompleteOrderPaymentTable";
import { PartnerOrderDetailReceiverTable } from "@/components/table/partner-order-receiver-table/PartnerOrderDetailReceiverTable";
import { H5 } from "@/components/typography/H5";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { useEffect } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

export const PartnerCompleteOrderPage = () => {
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const setCartItems = useSetRecoilState(
    selectedPartnerProductOrderCartItemsState,
  );

  useEffect(() => {
    setCartItems([]);
  }, []);
  if (!orderDetail) {
    return null;
  }

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] gap-[24px]">
        <PartnerCompleteOrderPanel orderDetail={orderDetail} />
        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">결제 정보</H5>
          </div>
          <PartnerCompleteOrderPaymentTable orderDetail={orderDetail} />
        </div>
        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">배송 정보</H5>
          </div>
          <PartnerOrderDetailReceiverTable orderDetail={orderDetail} />
        </div>
      </div>
    </PageWrapper>
  );
};
